import React, { useMemo,button } from "react";

import DataTable from "react-data-table-component";
import FilterComponent from "./FilterComponent";
import {RoleFilterComponent, PatientStatusFilterComponent,PracticeFilterComponent,DivisionFilterComponent,SmsDateFilterComponent,ActiveInactiveFilterComponent, MessageTemplate,WhatsAppCheck,CommunicationChannel} from "./CustomFilterComponent";
import * as XLSX from "xlsx"
import {formatDate} from "../../Services/CommonLibrary"
import {sendBulkReminder} from "../../Services/Service"
import styled from "styled-components";
import { WrapText } from "lucide-react";
import {formatUkNumber} from "../Utils";

const Table = props => {
  
  const columns = props.column;
  const show = props.show || 'Y';
  const title = props.title;
  const exportCSV = props.exportCSV;
  const csvName = props.csvName;
  const customFilterRole = props.filterRole;
  const customFilterActiveInActive = props.filterActiveInactive;
  const customFilterStatus = props.filterStatus;
  const customFilterPractice = props.filterPractice;
  const customFilterDivision = props.filterDivision;
  const customFilterSmsDate = props.filterSmsDate;
  const showClearbtn = props.showClearbtn;
  const showSendBtn = props.showSendBtn;
  const showTemplate = props.showTemplate;
  const showFilter = props.showFilter;
  const [selectedValue, setSelectedValue] = React.useState(1);
  const [checkedItems, setCheckedItems] = React.useState({
    whatsApp: true,
    sms: true,
  });

 
  
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(
    false
  );
  const initialFilter = {roleFilter:'',statusFilter:'', practiceFilter:'',divisionFilter:'', smsStartFilter:'', smsEndFilter:'',activeInactiveFilter:""}
  const [filterCondition, setFilterCondition] = React.useState(initialFilter);
  
  const list =
    Array.isArray(props.data)
      ? props.data
      : Array.isArray(props.data?.data)
      ? props.data.data
      : [];

  let filteredItems = list.filter(item =>
    JSON.stringify(item).toLowerCase().includes(filterText.toLowerCase())
  );


  console.log("filteredItems",filteredItems);
  
  if(filterCondition.activeInactiveFilter!=''){
    console.log("HERE");
    filteredItems = filteredItems.filter(item => item.status === filterCondition.activeInactiveFilter);
    console.log('filteredItems',filteredItems.length)
  }

  if(filterCondition.roleFilter!=''){
    filteredItems = filteredItems.filter(item => item.role === filterCondition.roleFilter);
  }
  
  if(filterCondition.practiceFilter!=''){
    filteredItems = filteredItems.filter(item => item.clinicName === filterCondition.practiceFilter);
  }
  
  if(filterCondition.divisionFilter!=''){
    filteredItems = filteredItems.filter(item => item.division === filterCondition.divisionFilter);
  }
  if(filterCondition.smsStartFilter!='' && filterCondition.smsEndFilter!=''){
    // console.log(filterCondition.smsStartFilter,filterCondition.smsEndFilter)
    filteredItems = filteredItems.filter(item => (formatDate(item.createdTime) >= formatDate(filterCondition.smsStartFilter) && formatDate(item.createdTime) <= formatDate(filterCondition.smsEndFilter) ));
   
  }
  
  if(filterCondition.statusFilter!=''){
    const targetValue = filterCondition.statusFilter.split(':');
    console.log(targetValue,'targetValue111');
    if(targetValue[1]=='FOUND'){
      console.log("insideeee",targetValue[0]);
      filteredItems = filteredItems.filter(item => item[targetValue[0]] !== '-' && item[targetValue[0]] !== '' && item[targetValue[0]] !== null );

      console.log(filteredItems,'filteredItems-revised');

    }else if(targetValue[1]=='NOTFOUND'){
      filteredItems = filteredItems.filter(item => item[targetValue[0]] === '-');
    }else{
      filteredItems = filteredItems.filter(item => item[targetValue[0]] === targetValue[1]);
    }
    console.log("HERE");

    // filteredItems = filteredItems.filter(item => console.log(item[targetValue[0]]));
  
  }

  const sendReminder = (drpSelectedValue,checkedItems) => {

    const mobileNos = filteredItems.map(item => item.mobile);
    sendBulkReminder({mobileNos,drpSelectedValue,checkedItems})
    .then((res) => {
        // console.log("hello")
    });
    // console.log(mobileNos);
  }
  
  const handleExport = () => {
    const current = new Date();
    const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}, ${current.getHours()}:${current.getMinutes()}:${current.getSeconds()}`;
    var wb = XLSX.utils.book_new();

    if(csvName == 'Inclinic'){
      filteredItems.forEach(
        function(v){ 
          delete v.callId; delete v.scheduledForUserId; delete v.userId; delete v.scheduledByUserId; delete v.practiceId; delete v.callingType; delete v.expertFullName; delete v.callNotesDisplay;  
        });
    }
    
    if(csvName == 'User List'){
      filteredItems.forEach(function(v){ delete v.userId; delete v.goqiiUserId; delete v.encPatientId; delete v.userImageUrl; delete v.buttonDisplay; delete v.buttonName; delete v.encPatientIdWithType; delete v.subscriptionStartDate; delete v.subscriptionEndDate;});
    }
    

    var ws = XLSX.utils.json_to_sheet(filteredItems);
    XLSX.utils.book_append_sheet(wb, ws, `${csvName}`);
    XLSX.writeFile(wb,`${csvName} ${date}.csv`);
  }
  const subHeaderComponent = useMemo(() => {
    
    return (
      <>
      {/* <FilterComponent
        onFilter={e => setFilterText(e.target.value)}
        filterText={filterText}
        exportCSV={exportCSV}
        callbackExport={handleExport}
      /> */}
      </>
    );

  }, [filterText, resetPaginationToggle]);

 const exportComponent = useMemo(()=>{
  return (
    <button onClick={handleExport} className="btn btn-success btn-sm r-2">EXPORT</button>
  );
 })
 
 const handleClear = () => {
  if (filterText) {
    setResetPaginationToggle(!resetPaginationToggle);
    setFilterText("");
  }
};
 
 const ExtrafilterComponent = useMemo(()=>{
  
  const filtertableData=(event)=>{
    const tarname = event.target.name
    console.log('call',event.target.value);
    setFilterCondition({...filterCondition,[tarname]:event.target.value})
   }
   const filtertableDataDate=(data)=>{
    // console.log(data);
    setFilterCondition({...filterCondition,['smsStartFilter']:data[0].startDate, ['smsEndFilter']:data[0].endDate})
   }

   const updateTemplate = async (event)=>{
    const tarname = event.target.name;
    const templateValue = event.target.value;
    setSelectedValue(templateValue);
   }  

  const handleCheckboxChange = (checkboxName) => {
    setCheckedItems((prevCheckedItems) => ({
      ...prevCheckedItems,
      [checkboxName]: !prevCheckedItems[checkboxName],
    }));
    // console.log(checkedItems)
  };

  return (
    <>
    {showFilter ?
        <div className={`col-md-${showTemplate ? 9 : 12}`} style={{display: 'flex', justifyContent: 'end', alignItems: 'center'}} >
          <div className=' mb-2' style={{display: '-webkit-box',float: 'right'}}>
              {customFilterStatus?<div className={`col-md-${showTemplate ? 2: 2} pe-0`}>
                <PatientStatusFilterComponent filterParam={filterCondition} onChange={filtertableData} />
              </div> : null }
              {customFilterPractice?<div className={`col-md-${showTemplate ? 2: 3} pe-0`}>
                <PracticeFilterComponent filterParam={filterCondition} onChange={filtertableData} />
              </div> : null }
              {customFilterDivision?<div className={`col-md-${showTemplate ? 2: 3} pe-0`}>
                <DivisionFilterComponent filterParam={filterCondition} onChange={filtertableData} />
              </div> : null }
              {customFilterSmsDate?<div className={`col-md-${showTemplate ? 3: 3} pe-0`}>
                <SmsDateFilterComponent filterParam={filterCondition} onClick={filtertableDataDate} />
              </div> : null }
              {showClearbtn ? <div className="col-md-1">
                <button type="button"  className="btn btn-success btn-sm" style={{width: '100%'}} onClick={(e)=>{setFilterCondition(initialFilter)}}>Clear</button>
              </div>:null }
              <div className="col-md-3 pe-0 mt-2" style={{display: 'contents'}}>
                {customFilterRole?<RoleFilterComponent filterParam={filterCondition} onChange={filtertableData} /> : null }
              </div>
              <div className="col-md-3 pe-0 mt-2" style={{display: 'contents'}}>
                {customFilterActiveInActive?<ActiveInactiveFilterComponent filterParam={filterCondition} onChange={filtertableData} /> : null }
              </div>
          <div className='row mt-3' style={{display: 'contents'}}>
            {showTemplate?<WhatsAppCheck checkedItems={checkedItems} onChange={handleCheckboxChange} /> : null }
            {showTemplate?<CommunicationChannel selectedValue={selectedValue} onChange={updateTemplate} /> : null }
          </div>
          <div className='col-md-12 row mt-2' style={{display: 'contents'}}>
              {showSendBtn ? <div className="col-md-12">
                <button type="button"  className="btn btn-success btn-sm mt-2 mb-3" onClick={(e)=>{sendReminder(selectedValue,checkedItems)}}>Send Reminder to {filteredItems.length} Patients</button>
              </div> : null}
          </div>
        </div>
        {showTemplate? <div className='col-md-3 mt-3' style={{display: 'contents'}}> 
           <MessageTemplate selectedValue={selectedValue} onChange={filtertableData} /> 
         </div>: null } 
      </div> : null }


    {/* {customFilterSmsDate?<SmsDateFilterComponent filterParam={filterCondition} onClick={filtertableDataDate} /> : null } */}
    {/* {customFilterRole?<RoleFilterComponent filterParam={filterCondition} onChange={filtertableData} /> : null } */}

    {/* {customFilterActiveInActive?<ActiveInactiveFilterComponent filterParam={filterCondition} onChange={filtertableData} /> : null } */}

    {/* {customFilterStatus?<PatientStatusFilterComponent filterParam={filterCondition} onChange={filtertableData} /> : null } */}
    {/* {customFilterPractice?<PracticeFilterComponent filterParam={filterCondition} onChange={filtertableData} /> : null } */}
    
    {/* <div className="d-flex">
      {customFilterDivision?<DivisionFilterComponent filterParam={filterCondition} onChange={filtertableData} /> : null }
    </div> */}
    {/* {customFilterPractice?<MessageTemplate filterParam={filterCondition} onChange={filtertableData} /> : null } */}
    {/* {customFilterDivision?<WhatsAppCheck filterParam={filterCondition} onChange={filtertableData} /> : null } */}
    {/* {customFilterDivision?<CommunicationChannel filterParam={filterCondition} onChange={filtertableData} /> : null } */}




    {/* {showClearbtn?<button type="button"  className="btn btn-success btn-sm me-1" onClick={(e)=>{setFilterCondition(initialFilter)}}>Clear</button>:null } */}

    {/* <div className="col-12 mb-1"></div>    */}
    </>
  );
 }, [filterCondition.roleFilter,filterCondition.statusFilter,filterCondition.practiceFilter, filterCondition.divisionFilter,filterCondition.smsStartFilter,filterCondition.smsEndFilter, filteredItems,resetPaginationToggle]);

  const customStyles = {
    rows: {
        style: {
            // minHeight: '72px', 
            // override the row height
        },
    },
    headCells: {
        style: {
            paddingLeft: '0px', // override the cell padding for head cells
            paddingRight: '0px',
            backgroundColor: "#c5c1c1",
            color: '#000',
            fontSize: '0.9rem',
            width: '100%',
            minWidth: '300px',
        },
    },
    cells: {
        style: {
            paddingLeft: '2px', // override the cell padding for data cells
            paddingRight: '2px',
            paddingTop: '0.1rem',
            paddingBottom: '0.1rem',
        },
    },
    
    
};


const onChangePage=page=>{
  if(props.onChangePage){
    props.onChangePage(page);
  }
}
  return (
    <>
     {/* <span>count:{filteredItems.length}</span>    */}
    <DataTable
      title= {<>
      <div className="col-md-12">
        <div className="row mt-3 mb-2" style={{display: '-webkit-box'}}>
            <div className="col-md-8 pe-0">
                <div>
                <h1 className="title">{title}</h1>
                </div>
            </div>
        </div>
    </div>
    <div className="col-md-12">
        <div className="row mt-3 mb-2" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center',paddingRight: '5px'}}>
            <div className={`col-md-${exportCSV ? 8: 8} pe-0`}>
                <div>
                  <h4 className="mb-1">Total: {formatUkNumber(filteredItems?.length)}</h4>
                </div>
            </div>
            <div className={`col-md-${exportCSV ? 3: 4} pe-0`}>
                <div className="d-flex" style={{ marginRight:"10px"}} >
                  {show=='Y' && (
                    <FilterComponent
                  onFilter={e => setFilterText(e.target.value)}
                  filterText={filterText}
                  onClear={handleClear} show="N"/>)}
                </div>
            </div>
            <div className="col-md-1 pe-0 mt-2" style={{display: 'contents'}}>
              {exportCSV ? <>  {exportComponent}</>  : null}
            </div>
        </div>
    </div>
             </>
        }
      columns={columns}
      data={filteredItems}
      defaultSortField="name"
      striped
      pagination
      paginationPerPage="50"
      paginationRowsPerPageOptions={[50,100,150,200]}
      subHeader
      order-column
      subHeaderComponent={ <>{ExtrafilterComponent}{subHeaderComponent}</>}    
      customStyles={customStyles}  
      onChangePage={onChangePage}
    />
   
    </>
  );
};

export default Table;
